export default "__VITE_ASSET__CL40UkPc__"